// frontend/src/main.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import { initTheme } from './services/theme';
import { AuthProvider } from './context/AuthContext';

// ======================= Inicialización de tema =======================
// Aplica modo oscuro / claro / automático antes de renderizar
try {
  initTheme();
} catch (e) {
  console.warn('[theme] initTheme falló (continuando):', e);
}

// =========================== Root seguro ==============================
let rootEl = document.getElementById('root');
if (!rootEl) {
  rootEl = document.createElement('div');
  rootEl.id = 'root';
  document.body.appendChild(rootEl);
}

// Vite expone import.meta.env.BASE_URL (p.ej. "/").
// BrowserRouter espera basename sin la barra final.
const rawBase = import.meta.env.BASE_URL ?? '/';
const basename = rawBase.endsWith('/') ? rawBase.slice(0, -1) : rawBase;

// ========================= Render con fallback ========================
function safeRender() {
  try {
    createRoot(rootEl!).render(
      <React.StrictMode>
        {/* Router DEBE envolver al AuthProvider si éste usa useNavigate */}
        <BrowserRouter basename={basename}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  } catch (err) {
    console.error('Render error:', err);
    (rootEl as HTMLElement).innerHTML = `
      <div style="padding:24px;font-family:system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Arial;">
        <h2>Hubo un error montando la aplicación</h2>
        <p style="color:#a00;margin-top:8px">${(err as Error)?.message ?? 'Error desconocido'}</p>
        <p style="margin-top:12px">Revisa la consola del navegador para más detalles.</p>
      </div>
    `;
  }
}

safeRender();
